__turbopack_context__.v({
  "description": "styles-module__ecBNUG__description",
});
